export enum ExamsDataTestIdEnum {
  MAIN_EXAMS_LIST = 'exams--main-exams-list',
  EXAMS_LIST = 'exams--list',
  CTA_INDEX_CARD_TITLE = 'cta-index-card--title',
  CTA_INDEX_CARD_DESCRIPTION = 'cta-index-card--description',
  CTA_INDEX_CARD_BUTTON_PRIMARY = 'cta-index-card--button-primary',
  CTA_INDEX_CARD_BUTTON_SECONDARY = 'cta-index-card--button-secondary',
  BRANDING_VALUES_TITLE = 'branding-values--title',
  BRANDING_VALUES_DESCRIPTION = 'branding-values--description',
  INDEX_PROCEDURES_IN_CITY_TITLE = 'index-procedures-in-city--title',
  INDEX_PROCEDURES_IN_CITY_LINK = 'index-procedures-in-city--link',
  SEE_MORE_INDEX_BUTTON_LINK = 'see-more-index-button--link',
  INDEX_POST_CONTENT = 'index-post--content',
}
